import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ImageUploader, Media } from "src/app/core/services/interface";
import { DeleteMyGallery, GetMyMedia } from "src/app/core/services/outbound";
import { WebsocketService } from "src/app/core/services/websocket.service";
import Axios, { AxiosResponse, AxiosError } from "axios";
import { environment } from "src/environments/environment";
import {
  DropzoneComponent,
  DropzoneConfigInterface,
  DropzoneDirective,
} from "ngx-dropzone-wrapper";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { BlobService } from "src/app/sharedservices/blob.service";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import {
  CdkDragDrop,
  CdkDragEnter,
  CdkDragMove,
  CdkDragStart,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import Swal from "sweetalert2";
import { MediaPlayerComponent } from "src/app/shared/media-player/media-player.component";

@Component({
  selector: "app-dropzone-center",
  templateUrl: "./dropzone-center.component.html",
  styleUrls: ["./dropzone-center.component.scss"],
})

/**
 * UI-Image-cropper component
 */
export class DropzoneCenterComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  constructor(
    public ws: WebsocketService,
    private formBuilder: UntypedFormBuilder,
    private modalService: BsModalService,
    private blobService: BlobService,
    private mdw: MiddlwareService,
    private _ref: ChangeDetectorRef
  ) {}

  @Input() data: ImageUploader = {
    id: "slider",
    title: "Slider Images",
    max: 2,
    resizeToWidth: 500,
    resizeToHeight: 500,
    cropperView: false,
    removePadding: false,
    removeButton: false,
    selectedImages: [],
    hideImagesDisplays: false,
    keyword: "calendar",
    mode: ["upload", "gallery", "url"],
  };
  @Input() removePadding = false;
  @Input() isDisabled = false;
  @ViewChild("largeDataModal") myModal;
  @ViewChild("main", { static: false }) componentRef?: DropzoneComponent;
  @ViewChild(DropzoneDirective, { static: false })
  directiveRef?: DropzoneDirective;
  @Output() images = new EventEmitter<any[]>();
  @Output() cancel = new EventEmitter<boolean>(false);
  @Output() fileAdd = new EventEmitter<boolean>(false);
  @Output() error = new EventEmitter<boolean>(false);
  mediaType: string = "image";
  verifySubscription: any;
  myGallerySubscription: any;
  deleteMyGallerySubscription: any;
  @Input() mediaData: Media[] = [];
  mediaPreviewData: Media[] = [];
  mediaSelectedImages: any[] = [];
  @Input() currentImages: any[] = [];
  selectedImages: any[] = [];
  urlForm: UntypedFormGroup;
  submitted = false;
  collapseMedia = true;
  modalRef?: BsModalRef;
  file: any;
  aspectRatio;
  resizeToWidth = 0;
  resizeToHeight = 0;
  orgFile: any;
  uploading = false;
  component_ref: any;
  mediaList: {};
  pageSize = 24;
  currentPage = 0;
  chat_id: string;
  eop = false;
  showCanvas = true;
  toggleDropZone = false;
  imageCount: number = 0;

  public dropzoneConfig: DropzoneConfigInterface = {
    resizeQuality: 100,
    // resizeWidth: 140,
    // resizeHeight: 280,
    thumbnailMethod: "contain",
    resizeMethod: "contain",
    addRemoveLinks: true,
    previewsContainer: false,
  };

  uploadimage: any;

  selectedItem: string;
  imageIndex: number;
  opjectImage;
  dragPreviewStyle = {};
  regURL =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;
  tokenChangeSubscription: any;

  ngOnInit(): void {
    this.component_ref = this.mdw.makeRef(16);
    // this.data.id = this.mdw.makeRef(16);
    this.dropzoneConfig = {
      ...this.dropzoneConfig,
      url: (file) => {
        let url =
          environment.http_upload_url + "?bin=1&cache=1&p=1&ct=" + file[0].type;
        if (
          this.data.media_type == "video" ||
          this.data.media_type == "audio"
        ) {
          url =
            environment.http_upload_msg_url +
            file[0].name +
            "?bin=1&p=1&ct=" +
            file[0].type +
            "&cache=1";
        }
        if (this.data.aspectRatio && file[0].type.includes("image")) {
          url = url + `&ar=${this.data.aspectRatio}`;
        }
        if (this.data.keyword) {
          url = url + `&kw=${this.data.keyword}`;
        }
        return url;
      },
      method: "put",
      headers: {
        "Cache-Control": false,
        "X-TOKEN": localStorage.getItem("token"),
      },
      init: function () {
        this.on("addedfile", function (file) {

          const isGif = file.type === "image/gif";
          if (!isGif) {
            this.options.resizeWidth = this.data && this.data.resizeToWidth ? this.data.resizeToWidth : 360;
            this.options.resizeHeight = this.data && this.data.resizeToHeight ? this.data.resizeToHeight : 360;
          } else {
            delete this.options.resizeWidth;
            delete this.options.resizeHeight;
          }
        });
      },
    };

    this.mediaList = {};
    this.currentPage = 1;
    this.chat_id = localStorage.getItem("chat_id");

    this.urlForm = this.formBuilder.group({
      imageUrl: new UntypedFormControl("", [
        Validators.required,
        Validators.pattern(this.regURL),
      ]),
    });
    this.tokenChangeSubscription = this.ws.tokenChangeContainer$.subscribe(
      (data) => {
        if (data) {
          this.dropzoneConfig = {
            ...this.dropzoneConfig,
            headers: {
              "Cache-Control": false,
              "X-TOKEN": localStorage.getItem("token"),
            },
          };
        }
      }
    );


    this.verifySubscription = this.ws.verifyContainer$.subscribe(
      (verifyData) => {
        // console.log("verifyData"+ verifyData);
        if (verifyData && this.data.removeButton) {
        }
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.currentImages && changes.currentImages.currentValue) {
      this.mediaList = {};

      for (let i = 0; i < this.currentImages.length; i++) {
        const media: Media = {
          width: this.mediaData[i] && this.mediaData[i].width ? this.mediaData[i].width : 0,
          hieght: this.mediaData[i] && this.mediaData[i].hieght ? this.mediaData[i].hieght : 0,
          url: this.currentImages[i],
          id: this.mdw.makeRef(16),
        };
        this.mediaList[media.id] = media;
      }
      this.mediaData = Object.values(this.mediaList);
    }

    if (changes.data && changes.data.currentValue) {
      this.data = changes.data.currentValue;

      if (this.data) {
        if (this.data.aspectRatio) {
          const aspectNumber = this.data.aspectRatio.split("x");
          this.aspectRatio = Number(aspectNumber[0]) / Number(aspectNumber[1]);
        }
        // if (this.data.resizeToWidth) {
        //   this.resizeToWidth = this.data.resizeToWidth;
        //   this.dropzoneConfig.resizeWidth = this.data.resizeToWidth;
        // }
        // if (this.data.resizeToHeight) {
        //   this.resizeToHeight = this.data.resizeToHeight;
        //   this.dropzoneConfig.resizeHeight = this.data.resizeToHeight;
        // }
        if (this.data.selectedImages && this.data.selectedImages.length > 0) {
          this.selectedImages = [...this.data.selectedImages];
        }

        if (this.data.removeButton) {
          this.collapseMedia = false;
        }

        if (this.data.keyword) {
          this.selectedItem = this.data.keyword;
        }
        if (this.data.acceptedFiles) {
          this.dropzoneConfig.acceptedFiles = this.data.acceptedFiles;
        }
        if (this.data.maxFileSize) {
          this.dropzoneConfig.maxFilesize = this.data.maxFileSize;
        }
      }
    }
  }

  ngAfterViewInit(): void {}

  get f() {
    return this.urlForm.controls;
  }

  addImages(image, status) {
    if (status) {
      const id = this.mdw.makeRef(16);
      const mediaData = {
        id,
        media: image,
      };
      if (this.data.max == 1) {
        this.mediaSelectedImages = [mediaData];
      } else {
        if (
          this.data.max !=
          this.selectedImages.length + this.mediaSelectedImages.length
        ) {
          this.mediaSelectedImages.push(mediaData);
        }
      }
    } else {
      this.mediaSelectedImages = this.mediaSelectedImages.filter(
        (img) => img.media.id !== image.id
      );
    }
  }

  useSelected() {
    this.selectedImages = [...this.selectedImages, ...this.mediaSelectedImages];
    this.mediaSelectedImages = [];
    if (!this.data.removeButton) {
      this.collapseMedia = !this.collapseMedia;
    }
    this.images.emit(this.selectedImages);
  }

  deleteMyGallarySelected() {
    this.mediaSelectedImages.map((image: any) => {
      this.ws.processMethod(new DeleteMyGallery(image.media.id));
    });
    this.mediaSelectedImages = [];
  }

  deleteSelected(img) {
    this.selectedImages = this.selectedImages.filter(
      (image) => image.id !== img.id
    );
    this.images.emit(this.selectedImages);
  }

  addImageUrl() {
    this.submitted = true;
    if (this.urlForm.invalid) {
    } else {
      var filename = this.urlForm.value.imageUrl.split("/").pop();
      const id = this.mdw.makeRef(16);
      const media: Media = {
        filename: filename,
        permanentUrl: this.urlForm.value.imageUrl,
      };
      const mediaData = {
        id,
        media: media,
        url: this.urlForm.value.imageUrl,
      };
      this.mediaList[mediaData.id] = mediaData;
      this.mediaData = [];
      this.mediaData = Object.values(this.mediaList);
      this.urlForm.reset();
      this.submitted = false;
      this.images.emit(this.mediaData);
    }
  }

  isImageSelected(status: boolean) {
    if (status) {
      return {
        border: "2px solid",
      };
    }
  }

  isRetchTheMax() {
    if (
      this.data.max != 1 &&
      this.data.max ==
        this.selectedImages.length + this.mediaSelectedImages.length
    ) {
      return true;
    } else {
      return false;
    }
  }

  async onFileAdded(event, modal) {
    // if(event.status == 'success'){
    const file = event.target.files[0];

    // Encode the file using the FileReader API
    if (file != null) {
      const blopFile = await this.blobService.createBlobFile(file);
      const blopUrl = await this.blobService.getblobURL(blopFile);
      this.blobService.getImageMetadata(blopUrl).then((imageMetadata: any) => {
        this.orgFile = file;
        if (!this.aspectRatio) {
          this.aspectRatio = imageMetadata.width / imageMetadata.height;
        }
        if (imageMetadata.height >= imageMetadata.width) {
          if (this.resizeToHeight == 0) {
            if (file.height > 512) {
              this.resizeToHeight = 512;
            } else {
              this.resizeToHeight = imageMetadata.height;
            }
          }
        } else {
          if (this.resizeToWidth == 0) {
            if (imageMetadata.width > 512) {
              this.resizeToWidth = 512;
            } else {
              this.resizeToWidth = imageMetadata.width;
            }
          }
        }
        this.largeModal(modal);
      });
    }
    // }
  }

  largeModal(largeDataModal: any) {
    this.modalRef = this.modalService.show(largeDataModal, {
      class: "modal-dialog-centered modal-xl",
    });
  }

  isMediaSelected(media) {
    return (
      this.mediaSelectedImages.filter((res) => res.media.id === media.id)
        .length > 0
    );
  }

  onSuccess(val) {
    let [file, serverResponse] = val;

    const media: Media = {
      ...serverResponse.media,
      url: serverResponse.media.permanentUrl,
      filename: serverResponse.file,
      thumbnail: serverResponse.thumbnail,
      id: file.upload.uuid,
    };
    this.mediaList[file.upload.uuid] = media;
    this.mediaData = [];
    this.mediaData = Object.values(this.mediaList);
    this.imageCount = this.imageCount - 1;
    this.images.emit(this.mediaData);

    if (this.imageCount == 0) {
      this.fileAdd.emit(false);
    }
  }

  selectSlotImage(list: any[]) {
    for (let i = 0; i < list.length; i++) {
      const media: Media = {
        ...list[i],
        url: list[i].media.permanentUrl,
        filename: list[i].media.filename,
        id: list[i].id,
      };
      this.mediaList[list[i].id] = media;
    }
    this.mediaData = [];
    this.mediaData = Object.values(this.mediaList);
    this.images.emit(this.mediaData);
    this.modalRef?.hide();
  }

  async filesAdd(files) {
    let opject = {};
    if (Array.isArray(files)) {
      for (let i = 0; i < files.length; i++) {
        if (files[i].status !== "error") {
          // this.dropzoneConfig = this.getDropzoneConfig(files[i].type);
          const blopFile = await this.blobService.createBlobFile(files[i]);
          const blopUrl = await this.blobService.getblobURL(blopFile);
          const opjectImage = {
            id: files[i].upload.uuid,
            filename: files[i].name,
            status: "upload",
            url: blopUrl,
          };
          opject[opjectImage.id] = opjectImage;
        }
      }
      this.mediaList = { ...opject, ...this.mediaList };
      this.mediaData = Object.values(this.mediaList);
      this.imageCount = this.imageCount + Number(files.length);
    } else {
      if (files[0].status !== "error") {
        // this.dropzoneConfig = this.getDropzoneConfig(files[0].type);
        const blopFile = await this.blobService.createBlobFile(files[0]);
        const blopUrl = await this.blobService.getblobURL(blopFile);
        const opjectImage = {
          id: files[0].upload.uuid,
          filename: files[0].name,
          status: "upload",
          url: blopUrl,
        };
        opject[opjectImage.id] = opjectImage;
        this.mediaList = { ...opject, ...this.mediaList };
        this.mediaData = Object.values(this.mediaList);
        this.imageCount = this.imageCount + 1;
      }
    }

    this.fileAdd.emit(true);
  }

  cancelMedia() {
    this.cancel.emit();
  }

  onDragEnter(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleDropZone = true;
  }
  onDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggleDropZone = false;
  }

  drope(event: CdkDragDrop<any>) {
    const drag = event.item;
    const dropList = event.container;
    const dragIndex = drag.data;
    const dropIndex = dropList.data;
    moveItemInArray(this.mediaData, dragIndex.index, dropIndex.index);
    this.images.emit(this.mediaData);
  }

  dragEntered(event: CdkDragEnter<any>, currentIndex) {
    let width = event.container.element.nativeElement.offsetWidth;
    let height = event.container.element.nativeElement.offsetHeight;
    this.dragPreviewStyle = {
      width: width + "px",
      height: height + "px",
    };
  }

  dragStart(event: CdkDragStart<any>, currentIndex) {
    // this.prevIndex = currentIndex;
    let width = event.source.dropContainer.element.nativeElement.offsetWidth;
    let height = event.source.dropContainer.element.nativeElement.offsetHeight;
    this.dragPreviewStyle = {
      width: width + "px",
      height: height + "px",
    };
  }

  dragMoved(event: CdkDragMove<number>) {}

  openMediaPlayer(media: Media, index: number): void {
    if (!media || !media.url) {
      return;
    }

    const initialState = {
      mediaUrl: media.url,
      mediaType: this.detectMediaTypeForPlayer(media.url),
      mediaList: this.mediaData,
      currentIndex: index,
    };

    this.modalService.show(MediaPlayerComponent, {
      initialState,
      class: "modal-lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  private detectMediaTypeForPlayer(url: string): string {
    if (!url) return "image";

    const cleanUrl = url.toLowerCase().split("?")[0].split("#")[0];

    if (
      /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(cleanUrl) ||
      cleanUrl.includes("image")
    ) {
      return "image";
    } else if (
      /\.(mp4|webm|ogg|mov|avi|mkv|flv)$/i.test(cleanUrl) ||
      cleanUrl.includes("video")
    ) {
      return "video";
    } else if (
      /\.(mp3|wav|ogg|m4a|aac|flac|amr|opus)$/i.test(cleanUrl) ||
      cleanUrl.includes("audio")
    ) {
      return "audio";
    } else if (cleanUrl.includes("youtube.com") || cleanUrl.includes("youtu.be")) {
      return "youtube";
    } else if (cleanUrl.includes("vimeo.com")) {
      return "vimeo";
    }
    return "image";
  }

  selectedImges(event, i) {
    const checked = event.target.checked;
    if (checked) {
      this.selectedImages.push(i);
    } else {
      this.selectedImages = this.selectedImages.filter((num) => num !== i);
    }
  }

  isImageUrl(url: string): boolean {
    // Remove query params and fragments
    const cleanUrl = url ? url.split("?")[0].split("#")[0] : "";
    return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(cleanUrl);
  }

  isVideoUrl(url: string): boolean {
    const cleanUrl = url ? url.split("?")[0].split("#")[0] : "";
    return /\.(mp4|webm|ogg|mov|avi|mkv|flv)$/i.test(cleanUrl);
  }

  isAudioUrl(url: string): boolean {
    const cleanUrl = url ? url.split("?")[0].split("#")[0] : "";
    return /\.(mp3|wav|ogg|m4a|aac|flac|amr|opus)$/i.test(cleanUrl);
  }

  removeImages() {
    this.selectedImages.forEach((media) => {
      delete this.mediaList[media];
    });
    this.mediaData = Object.values(this.mediaList);
    this.selectedImages = [];
    this.images.emit(this.mediaData);
  }

  onError(value) {
    const [file, error] = value;

    delete this.mediaList[file.upload.uuid];
    this.mediaData = Object.values(this.mediaList);
    Swal.fire("Upload failed", error, "error");
    this.error.emit(true);
  }

  getDropzoneConfig(fileType: string): DropzoneConfigInterface {
    if (fileType === "image/gif") {
      // No resize options for GIFs
      delete this.dropzoneConfig.resizeWidth;
      delete this.dropzoneConfig.resizeHeight;
      return {
        ...this.dropzoneConfig,
      };
    } else {
      // Normal config for other images
      return {
        ...this.dropzoneConfig,
        resizeWidth: this.data.resizeToWidth,
        resizeHeight: this.data.resizeToHeight,
      };
    }
  }

  ngOnDestroy(): void {
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
    if (this.myGallerySubscription) {
      this.myGallerySubscription.unsubscribe();
    }
    if (this.deleteMyGallerySubscription) {
      this.deleteMyGallerySubscription.unsubscribe();
    }
    if (this.tokenChangeSubscription) {
      this.tokenChangeSubscription.unsubscribe();
    }
  }
}
